import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  icon: {
    cursor: 'pointer',
  },
}));

export default useStyles;
